/**
 * Article card variants — re-exported under the system surface so that
 * theme overrides resolved through {@code resolveSystemPrimitive} have
 * a stable mounting point. The actual implementations live in
 * {@code ../cards/ArticleCard} and are also consumed directly by
 * {@code BlogArticleGrid}.
 *
 * <p>Three editorial registers:
 * <ul>
 *   <li>{@code image-led} — cover dominates. Default.</li>
 *   <li>{@code minimal} — text-only, hairline rules.</li>
 *   <li>{@code magazine} — cover + serif headline + dek + byline.</li>
 * </ul>
 *
 * <p>The active variant comes from
 * {@code shell.config.contentModule.blog.articleCardVariant} per
 * tenant. Theme overrides still win: if a theme ships a
 * SystemPrimitive override of {@code ArticleCard} in its bundle, the
 * layout's {@code resolveSystemPrimitive} returns it and the variant
 * is bypassed.
 */

export {
  ArticleCardImageLed,
  ArticleCardMinimal,
  ArticleCardMagazine,
  resolveArticleCard,
  type ArticleCardVariant,
  type ArticleCardProps,
} from '../cards/ArticleCard';
